const tas = [
  {
    name: "Janani Swaminathan",
    email: "swaminaj@oregonstate.edu"
  }
];

export default tas;
